import React, { useState, useContext, useEffect } from 'react';
import styled from 'styled-components';
import ENDPOINT from '../../../globals/api-endpoint';
import { AuthContext } from '../../../contexts/AuthContext';
import { Redirect, NavLink } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const LoginForm = styled.form`
	text-align: left;
	margin: 0 auto;
	padding: 0 20px;
	max-width: 300px;
`;

const LoginFormContainer = styled.div`
	margin: 50px auto;
	text-align: center;
	padding : 20px;
	border: 1px solid ${props => props.theme.green};
	border-radius: 5px;
	max-width: 350px;
`;

const Input = styled.input`
	color : white;
	background: ${props => props.theme.purple};
	font-size : 16px;
	border: 2px solid ${props => props.theme.purple};
	border-radius: 5px;
	text-align : center;
	margin: 5px;
	font-family: 'sans-serif';
	padding: 5px;
	transition: all 0.5s;
	&:hover {
		background: white;
		color : ${props => props.theme.purple};
		cursor: pointer;
	}
`;

const H3 = styled.h3`
	margin-bottom: 10px;
`;

const WarningStyled = styled.p`
	color: red;
`;

const InputStyled =styled.input`
	font-size : 14px;
	border: 2px solid ${props => props.theme.purple};
	border-radius: 5px;
	text-align : left;
	margin: 5px;
	font-family: 'sans-serif';
	padding: 5px;
	transition: all 0.5s;
`;

const InputContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr;
`;

const Login = (props) => {
	useEffect(() => {
	  window.scrollTo(0, 0)
	}, []);
	
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [isLoading, setIsLoading] = useState(false);
	const [isFailed, setIsFailed] = useState(false);

	const { auth, dispatch } = useContext(AuthContext);

	const handleEmailChange = (email) => {
		setEmail(email);
	}

	const handlePassChange = (pass) => {
		setPassword(pass);
	}

	const handleLogin = (e) => {
		e.preventDefault();
		setIsLoading(true)
		fetch(ENDPOINT.USER_LOGIN, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				email: email,
				password: password
			})
		})
		.then(res=> res.json())
		.then(res=> {
			if(res.message === 'Auth succesful') {
				setIsFailed(false);
				const authToken = {token: 'Bearer ' + res.token};
				localStorage.setItem('authToken', JSON.stringify(authToken));
				dispatch({ type: 'SWITCH_AUTH', auth: true });
			} else {
				setIsFailed(true);
			}
		})
		.catch(err => console.log(err))
		.finally(res => {
			setIsLoading(false);
		})
	}

	const loading = 
		<div className="loading">
			<div className="sk-folding-cube">
			  <div className="sk-cube1 sk-cube"></div>
			  <div className="sk-cube2 sk-cube"></div>
			  <div className="sk-cube4 sk-cube"></div>
			  <div className="sk-cube3 sk-cube"></div>
			</div>
		</div>
	;

	const loginFailed = isFailed ? (<WarningStyled>Gagal masuk, periksa email dan password anda</WarningStyled>) : (null);

	const Warning = email.length > 0 && password.length > 0? (null) : (<WarningStyled>Harap isi bidang email dan password dengan tepat</WarningStyled>);

	if (auth.isAuth) {
		 return <Redirect to={'/beranda'} />
	}

	if (isLoading) {
		return loading;
	} else {
		return(
			<LoginFormContainer onSubmit={handleLogin}>
				<Helmet>
					<title>login ke bantuin</title>
				</Helmet>
				<H3>Log Masuk</H3>
				<LoginForm>
					<InputContainer>
						<label htmlFor="email">Email :</label>
						<InputStyled type="text" value={email} onChange={(e) => handleEmailChange(e.target.value)}/>
					</InputContainer>
					<InputContainer>
						<label htmlFor="password">password :</label>
						<InputStyled type="password" value={password} onChange={(e) => handlePassChange(e.target.value)}/>
					</InputContainer>
					<Input type="submit" value="Masuk"/>
				</LoginForm>
				{ Warning }
				{ loginFailed }
				<NavLink to={'/signup'}>Belum punya akun? Daftar sekarang</NavLink>
			</LoginFormContainer>
		);
	}
}

export default Login;